exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cms-media-library__upload{position:absolute;width:100%;height:100%;background:hsla(0,0%,96.1%,.9);z-index:10;top:0;outline:3px dashed #2fa99e;outline-offset:-15px;text-align:center;font-size:2em;padding:150px 35% 0}.cms-media-library__upload>i.fa{font-size:4em;margin-bottom:20px;display:block}", ""]);

// exports
